import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActiveFileFilterChip, DateRangeFilter } from 'src/entities/file';

@Component({
  selector: 'app-file-programming-filters',
  templateUrl: './file-programming-filters.component.html',
  styleUrls: ['./file-programming-filters.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileProgrammingFiltersComponent {
  @Input() activeFilterChips: ActiveFileFilterChip[] = [];
  @Input() availableYears: string[] = [];
  @Input() clientOptions: string[] = [];
  @Input() clientSearchValue = '';
  @Input() fileStates: string[] = [];
  @Input() fileStatus: string | null = null;
  @Input() fileYear: string | null = null;
  @Input() hasActiveFilters = false;
  @Input() isLoadingClients = false;
  @Input() searchValidationMessage = '';
  @Input() searchValue = '';
  @Input() selectedNameClient: string | null = null;
  @Input() startDateFileRange: DateRangeFilter = { start: null, end: null };

  @Output() clientFilterChange = new EventEmitter<string | null>();
  @Output() clientSearchChange = new EventEmitter<string>();
  @Output() clearAllFilters = new EventEmitter<void>();
  @Output() clearDateRange = new EventEmitter<'startDateFileRange'>();
  @Output() filterQueued = new EventEmitter<void>();
  @Output() fileStatusChange = new EventEmitter<string | null>();
  @Output() fileYearChange = new EventEmitter<string | null>();
  @Output() removeFilter = new EventEmitter<string>();
  @Output() searchValueChange = new EventEmitter<string>();

  readonly trackByYear = (_: number, year: string) => year;
  readonly trackByState = (_: number, state: string) => state;
  readonly trackByClient = (_: number, client: string) => client;
  readonly trackByChip = (_: number, chip: ActiveFileFilterChip) => chip.id;

  onYearChange(value: string | null): void {
    const year = value ? value : null;
    this.fileYear = year;
    this.fileYearChange.emit(year);
    this.filterQueued.emit();
  }

  onStatusChange(value: string | null): void {
    const status = value ? value : null;
    this.fileStatus = status;
    this.fileStatusChange.emit(status);
    this.filterQueued.emit();
  }

  onSearchChange(value: string): void {
    this.searchValue = value;
    this.searchValueChange.emit(value);
  }

  onClientSearchChange(value: string): void {
    this.clientSearchValue = value;
    this.clientSearchChange.emit(value);
  }

  onClientSelected(nameClient: string): void {
    this.selectedNameClient = nameClient;
    this.clientSearchValue = nameClient;
    this.clientFilterChange.emit(nameClient);
  }

  clearClientFilter(): void {
    this.selectedNameClient = null;
    this.clientSearchValue = '';
    this.clientFilterChange.emit(null);
    this.clientSearchChange.emit('');
  }

  onDateRangeChange(): void {
    const { start, end } = this.startDateFileRange;
    if (start && end) {
      this.filterQueued.emit();
    }
  }
}
